// STYLES
import "./role.scss";

const Role = ({role}) => {
	return (
		<div className="personalData__role">
			<h3>{role}</h3>
		</div>
	);
};

export default Role;
